import "./JumboTabs-f518b164.js";
var e = /* @__PURE__ */ ((a) => (a.INCREASE = "increase", a.DECREASE = "decrease", a.CHANGE = "change", a))(e || {});
const r = [".pdf", ".png", ".jpg", ".jpeg"], s = 31457280, n = 15728640;
var d = /* @__PURE__ */ ((a) => (a.Blank = "blank", a.Uploaded = "uploaded", a.Uploading = "uploading", a.FailedUploaded = "failedUploaded", a))(d || {});
export {
  r as A,
  e as C,
  s as M,
  d as U,
  n as a
};
//# sourceMappingURL=constants.entry-2ac8013b.js.map
